import { Box } from '@mui/material'

const LogoContainer = ({ logoSource, altText, customWidth, customMT }) => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      height='150px'
      marginX='30px'
      sx={{
        width: {
          xs: customWidth || '300px',
          md: customWidth || '200px',
        },
      }}
    >
      <img
        src={logoSource}
        alt={altText}
        style={{
          width: '100%',
          objectFit: 'contain',
          marginTop: customMT || '0px',
          filter: 'brightness(0) invert(1)',
        }}
      />
    </Box>
  )
}

export default LogoContainer
